import { uniq } from "lodash";

import { Utils } from "utils";
import { IGraphhopperHit, IGraphoopperPath } from "types";

export class PathCountries {
  private _start?: IGraphhopperHit = undefined;
  private _finish?: IGraphhopperHit = undefined;

  constructor(private path: IGraphoopperPath) {
    this.path = path;
  }

  setCoordinates(
    start: IGraphhopperHit | undefined,
    finish: IGraphhopperHit | undefined
  ) {
    this._start = start;
    this._finish = finish;
  }

  /* Return Countries from path.countries param */
  getPathCountryCodes() {
    const countries = this.path.details.country;
    const values = countries.map((item) => item[2]);
    const list = values.map(Utils.Helpers.getCountryISO2).filter(Boolean);

    return uniq(list as string[]);
  }

  /* Generate Countries depends of start/finish/path.countries params  */
  /* If start && finish are in one country => return this country */
  /* If not => return getPathCountryCodes() */
  getCrossedCountryCodes() {
    const start = this._start;
    const finish = this._finish;

    if (start && finish) {
      const startCode = start.countrycode;
      const finsihCode = finish.countrycode;

      if (startCode === finsihCode) {
        return [startCode];
      }
    }

    return this.getPathCountryCodes();
  }
}
